import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  Users, 
  Trophy, 
  Building2,
  Heart,
} from 'lucide-react';

const navItems = [
  {
    label: 'CLB',
    icon: Building2,
    path: '/clubs',
  },
  {
    label: 'Người chơi',
    icon: Users,
    path: '/players',
  },
  {
    label: 'Xếp hạng',
    icon: Trophy,
    path: '/leaderboard',
  },
  {
    label: 'Theo dõi',
    icon: Heart,
    path: '/following',
  },
];

export function QuickNavMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bg-background/95 backdrop-blur-sm border-b border-border/50 sticky top-[49px] z-30">
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex items-center gap-1 px-3 py-2 min-w-max">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || 
                            location.pathname.startsWith(item.path + '/');
            const Icon = item.icon;
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all",
                  "whitespace-nowrap",
                  isActive 
                    ? "bg-primary text-primary-foreground shadow-sm" 
                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                )}
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
